import { useState, useEffect, useRef } from 'react';

// --- CONSTANTS FOR GUIDE FLOW ---
const GUIDE_FLOWS = {
    // यहाँ भविष्य में वर्कर के लिए स्टेप-बाय-स्टेप ट्यूटोरियल जोड़े जा सकते हैं 
    // जैसे: dashboard_intro, check_salary आदि।
};

const hindiWords = ["ज़ीरो", "एक", "दो", "तीन", "चार", "पांच", "छह", "सात", "आठ", "नौ", "दस", 
"ग्यारह", "बारह", "तेरह", "चौदह", "पंद्रह", "सोलह", "सत्रह", "अठारह", "उन्नीस", "बीस"];

// ये वो फील्ड्स और डिब्बे हैं जिन्हें बिना भरे 'आगे बढ़ें' किया जा सकता है
const OPTIONAL_FIELDS = [];

export const useWorkerSmartGuide = (onStartGuideReset) => {
    const [voiceAssist, setVoiceAssist] = useState(false);
    const [showGuideModal, setShowGuideModal] = useState(false);
    const [pendingConfirm, setPendingConfirm] = useState(null);
    const [activeGuideFlow, setActiveGuideFlow] = useState(null);
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    const voiceLoopRef = useRef(null);
    const targetElementRef = useRef(null);
    const lastAdvanceTime = useRef(0);

    function getHindiNumberText(num) {
        num = parseInt(num);
        if (isNaN(num)) return "";
        if (num === 0) return "जीरो";
        if (num < 100 && hindiWords[num]) return hindiWords[num];
        return num.toString();
    }

    const getStepMsg = (step) => {
        if (!step) return "";
        const m = step.msg || step.message;
        return typeof m === 'function' ? m() : m;
    };

    const speakHinglish = (msg) => {
        if (!window.speechSynthesis) return;
        
        window.speechSynthesis.cancel();
        
        // बारीक नियम: शब्दों का सुधार और .0 को हटाना
        let processedMsg = msg
            .replace(/Rs\./ig, 'रुपये')
            .replace(/kg/ig, 'किलो')
            .replace(/\btab\b/ig, 'टॅब')
            .replace(/\bm\b/ig, 'मीटर')
            .replace(/\bmar\b/ig, 'March')
            .replace(/\bnht\b/ig, 'NIGHT')
            .replace(/HOUR/ig, 'घंटा')      
            .replace(/MINUTE/ig, 'मिनट')    
            .replace(/\.0+(?!\d)/g, '') 
            .replace(/(\d)\.(\d)/g, '$1 पॉइंट $2'); // <--- YE NAYI LINE ADD KI GAYI HAI DOT (.) KE LIYE
            
        processedMsg = processedMsg.replace(/\d+/g, (match) => getHindiNumberText(match));

        const utterance = new SpeechSynthesisUtterance(processedMsg);
        utterance.lang = 'hi-IN'; 
        utterance.rate = 0.9; 
        
        setTimeout(() => {
            window.speechSynthesis.speak(utterance);
        }, 50);
    };
    const handleVoiceClick = (e, msg, originalAction, actionId = null, isAlreadyOpen = false, alreadyOpenMsg = null) => {
        if (e && e.stopPropagation) e.stopPropagation();
        if (e && e.preventDefault && originalAction) e.preventDefault();

        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
        }

        if (activeGuideFlow) {
            if (originalAction) originalAction(e);
            return;
        }

        if (voiceAssist) {
            if (isAlreadyOpen) { 
                speakHinglish(alreadyOpenMsg || " आप पहले से ही इस सेक्शन में मौजूद हैं."); 
                return; 
            }
            if (actionId && originalAction) {
                // डबल-क्लिक कन्फर्मेशन लॉजिक (स्मार्ट अपडेटेड)
                if (pendingConfirm === actionId) {
                    setPendingConfirm(null); 
                    originalAction(e);
                } else {
                        setPendingConfirm(actionId);
                        // 👇 यह सबसे ज़रूरी लाइन है: बटन से आया मैसेज पहले सेव होगा 
                        let confirmMsg = msg ? msg + " " : "";
                        
                        // --- WORKER APP SPECIFIC MESSAGES ---
                        if (actionId === 'nav-home') {
                            confirmMsg += " ये होम डैशबोर्ड पेज है, इसमें आप अपनी आज की ड्यूटी और प्रोडक्शन देख सकते हैं, देखना चाहते हैं तो दोबारा क्लिक करें।";
                        } else if (actionId === 'nav-history') {
                            confirmMsg += " ये प्रोडक्शन हिस्ट्री पेज है, इसमें आप अपनी प्रोडक्शन हिस्ट्री डिटेल में देख सकते हैं, देखना चाहते हैं तो दोबारा क्लिक करें।";
                        } else if (actionId === 'nav-payments') {
                            confirmMsg += " ये पेमेंट्स पेज बटन है, इसमें आप अपनी सैलरी और एडवांस की पेमेंट देख सकते हैं, देखना चाहते हैं तो दोबारा क्लिक करें।";
                        } else if (actionId === 'nav-jobs') {
                            confirmMsg += " ये जॉब्स पेज बटन है, यहाँ आप अलग-अलग टेक्सटाइल कारखानों में निकली जॉब वेकेंसीज़ देख सकते हैं, देखना चाहते हैं तो दोबारा क्लिक करें।";
                        } else if (actionId === 'btn-search' || actionId === 'btn-nav-search') {
                            confirmMsg += " इस सर्च बटन में जाने के लिए दोबारा क्लिक करें।";
                        } else if (actionId === 'btn-settings' || actionId === 'btn-nav-settings') {
                            confirmMsg += " ";
                        } else if (actionId === 'btn-profile' || actionId === 'btn-nav-profile') {
                            confirmMsg += " ";
                        } else if (actionId === 'btn-detailed-report-week') {
                            confirmMsg += " क्या आप इस हफ्ते के प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं? तो दोबारा क्लिक करें।";
                        } else if (actionId === 'btn-detailed-report-month') {
                            confirmMsg += " क्या आप इस महीने के प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं? तो दोबारा क्लिक करें।";
                        
                        } else if (actionId === 'btn-detailed-report-total') {
                            confirmMsg += " क्या आप टोटल प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं? तो दोबारा क्लिक करें।";
                       
                            } else if (actionId === 'btn-detailed-report') {
                            confirmMsg += " क्या आप अपनी पूरी डिटेल प्रोडक्शन रिपोर्ट देखना चाहते हैं? तो दोबारा क्लिक करें।";
                        } else if (actionId === 'tab-stats-today') {
                            confirmMsg += " ";
                        } else if (actionId === 'tab-stats-week') {

                            confirmMsg += " ";
                        } else if (actionId === 'tab-stats-month') {
                            confirmMsg += " ";
                        } else if (actionId === 'tab-stats-total') {
                            confirmMsg += " ";
                        
                        } else if (actionId === 'btn-logout') {
                            confirmMsg += " ऐप से बाहर निकलने (लॉग आउट) के लिए दोबारा क्लिक करें।";
                        } else {
                            if (!confirmMsg.includes("दोबारा क्लिक")) {
                                confirmMsg += " इसे कन्फर्म करने के लिए दोबारा क्लिक करें।";
                            }
                        }

                        speakHinglish(confirmMsg);
                    }
            } else {
                if (msg) speakHinglish(msg);
                if (originalAction) originalAction(e);
            }
        } else {
            if (originalAction) originalAction(e);
        }
    };

    const toggleVoiceAssist = () => {
        const newState = !voiceAssist;
        setVoiceAssist(newState);
        setPendingConfirm(null);
        if (newState) {
            speakHinglish(" Voice Guide On हो गया है. अब आप स्क्रीन पर जहाँ भी क्लिक करेंगे, आपको उसकी जानकारी दी जाएगी।");
        } else {
            window.speechSynthesis.cancel();
        }
    };

    const handleFocusVoice = (msg) => { if(voiceAssist && msg && !activeGuideFlow) speakHinglish(msg); };
    const handleSelectVoice = (val, fieldName) => { if(voiceAssist && val && !activeGuideFlow) speakHinglish(`आपने ${fieldName} में ${val} चुना है।`); };
    const handleTextBlurVoice = (val, fieldName) => { if(voiceAssist && val && !activeGuideFlow) speakHinglish(`आपने ${fieldName} में ${val} भरा है।`); };
    
     

    const startSmartGuide = (flowName) => {
        setShowGuideModal(false);
        setActiveGuideFlow(flowName);
        setCurrentStepIndex(0);
    };

    const cleanupGuideStep = () => {
        clearInterval(voiceLoopRef.current);
        if (targetElementRef.current) {
            const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
            els.forEach(el => { if (el && el.classList) el.classList.remove('smart-guide-target'); });
            targetElementRef.current = null;
        }
        
        const fakeDrop = document.getElementById('fake-dropdown-guide');
        if (fakeDrop) fakeDrop.remove();
    };

    const endSmartGuide = (isCanceled = false) => {
        cleanupGuideStep(); setActiveGuideFlow(null); setCurrentStepIndex(0);
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel(); 
        }
        if (!isCanceled) {
            speakHinglish(isCanceled ? " Smart Live Guide बंद कर दिया गया है." : " Live Guide Complete हो गया है. आपका शुक्रिया!");
        }
    };

    const advanceNextStep = (isManualClick = false) => {
        const now = Date.now();
        if (now - lastAdvanceTime.current < 400) return false;

        if (!activeGuideFlow) return false;
        const flow = GUIDE_FLOWS[activeGuideFlow];
        if (!flow || currentStepIndex >= flow.length) return false;

        const step = flow[currentStepIndex];
        let canAdvance = true;
        
        let errorMessage = step.errMsg || "पहले इस फील्ड को सही से भरें।";

        let els = [];
        if (step.targetClass) els = Array.from(document.querySelectorAll('.' + step.targetClass));
        else if (step.id) { const el = document.getElementById(step.id); if(el) els.push(el); }
        else if (step.targetId) { const el = document.getElementById(step.targetId); if(el) els.push(el); }

        const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);

        if (els.length > 0) {
            let inputsToCheck = [];
            els.forEach(el => {
                if (['INPUT', 'SELECT', 'TEXTAREA'].includes(el.tagName)) {
                    inputsToCheck.push(el);
                }
                const innerInputs = el.querySelectorAll('input, select, textarea');
                innerInputs.forEach(inner => inputsToCheck.push(inner));
            });

            if (inputsToCheck.length > 0) {
                let isFilled = inputsToCheck.some(el => {
                    if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) return el.checked;
                    return el.value !== undefined && el.value !== null && String(el.value).trim() !== '';
                });

                if (!isOptional && !isFilled) {
                    canAdvance = false;
                    errorMessage = step.errMsg || " यह फील्ड खाली है, इसे सही से भरें, उसके बाद ही 'Next Step' बटन पर क्लिक करके आगे बढ़ें।";
                }
            } else {
                if (!isOptional && isManualClick) {
                    canAdvance = false;
                    errorMessage = " shortcut का इस्तेमाल ना करें, Highlight किए गए Option पर ही क्लिक करें।";
                }
            }
        }

        if (!canAdvance) {
            speakHinglish(errorMessage);
            
            if (voiceLoopRef.current) {
                clearInterval(voiceLoopRef.current);
                const stepMsg = getStepMsg(step);
                voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 25000); 
            }

            els.forEach(el => {
                if (el) {
                    const originalShadow = el.style.boxShadow;
                    el.style.boxShadow = '0 0 0 4px #DC2626, 0 0 20px #DC2626';
                    setTimeout(() => { if (el) el.style.boxShadow = originalShadow; }, 1500);
                }
            });
            return false;
        }

        lastAdvanceTime.current = Date.now();
        setCurrentStepIndex(prev => prev + 1);
        return true;
    };

    useEffect(() => {
        if (!activeGuideFlow) return;

        const handleGlobalClick = (e) => {
            if (e.target.closest('#btn-stop-guide') || e.target.closest('#btn-next-step')) return;
            
            const flow = GUIDE_FLOWS[activeGuideFlow];
            const step = flow ? flow[currentStepIndex] : null;

            if (targetElementRef.current) {
                const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                
                if (els.some(el => el.contains(e.target))) {
                    if (step && step.id === 'shift-filters') {
                        setTimeout(() => {
                            const nextBtn = document.getElementById('btn-next-step');
                            if (nextBtn) nextBtn.click();
                        }, 300); 
                    }
                    return; 
                }
            }
            
            const nextStep = flow ? flow[currentStepIndex + 1] : null;
            if (nextStep) {
                let nextEls = [];
                if (nextStep.targetClass) nextEls = Array.from(document.querySelectorAll('.' + nextStep.targetClass));
                else if (nextStep.id) { const el = document.getElementById(nextStep.id); if (el) nextEls.push(el); }
                else if (nextStep.targetId) { const el = document.getElementById(nextStep.targetId); if (el) nextEls.push(el); }
                
                if (nextEls.some(el => el.contains(e.target))) {
                    const success = advanceNextStep(false);
                    if (!success) { e.preventDefault(); e.stopPropagation(); }
                    return; 
                }
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            if (!step) return;

            const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);

            if (isOptional) {
                speakHinglish(" कृपया हाईलाइट किए गए हिस्से पर काम करें या 'Next Step' बटन दबाएं।");
            } else {
                speakHinglish(step.errMsg || "पहले हाईलाइट कि गई फील्ड भरे और 'Next Step' बटन पर क्लिक करें।");
                
                if (voiceLoopRef.current) {
                    clearInterval(voiceLoopRef.current);
                    const stepMsg = getStepMsg(step);
                    voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 12000);
                }

                if (targetElementRef.current) {
                    const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                    els.forEach(el => {
                        if (el) {
                            const originalShadow = el.style.boxShadow;
                            el.style.boxShadow = '0 0 0 4px #DC2626, 0 0 20px #DC2626';
                            setTimeout(() => { if (el) el.style.boxShadow = originalShadow; }, 1500);
                        }
                    });
                }
            }
        };
        
        document.addEventListener('click', handleGlobalClick, true);
        return () => { document.removeEventListener('click', handleGlobalClick, true); };
    }, [activeGuideFlow, currentStepIndex]);

    useEffect(() => {
        if (!activeGuideFlow) return;
        const flow = GUIDE_FLOWS[activeGuideFlow];
        if (!flow || currentStepIndex >= flow.length) { endSmartGuide(false); return; }

        const step = flow[currentStepIndex];
        let retryCount = 0;
        let handler;

        const findAndHighlight = () => {
            let els = [];
            if (step.targetClass) els = Array.from(document.querySelectorAll('.' + step.targetClass));
            else if (step.id) { const el = document.getElementById(step.id); if (el) els.push(el); }
            else if (step.targetId) { const el = document.getElementById(step.targetId); if (el) els.push(el); }

            if (els.length > 0) {
                cleanupGuideStep();
                targetElementRef.current = els;
                els.forEach(el => el.classList.add('smart-guide-target'));
                
                const stepMsg = getStepMsg(step);
                speakHinglish(stepMsg);
                voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 12000); 

               handler = (e) => {
                    if (e.type === 'keydown' && e.key !== 'Enter') return; 
                    if (e.type === 'keydown') e.preventDefault(); 

                    setTimeout(() => {
                        const success = advanceNextStep(false); 
                        if (success) {
                            const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                            els.forEach(el => eventTypes.forEach(t => el.removeEventListener(t, handler)));
                        }
                    }, 200); 
                };
                
                const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                els.forEach(el => eventTypes.forEach(t => el.addEventListener(t, handler)));

            } else {
                const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);
                
                if (isOptional) {
                    if (retryCount < 6) { 
                        retryCount++; 
                        setTimeout(findAndHighlight, 500); 
                    } else { 
                        setCurrentStepIndex(prev => prev + 1); 
                    }
                } else {
                    if (retryCount < 40) { 
                        retryCount++; 
                        setTimeout(findAndHighlight, 500); 
                    } else { 
                        endSmartGuide(true);}
                }
            }
        };

        findAndHighlight();

        return () => {
            cleanupGuideStep();
            if (targetElementRef.current && handler) {
                const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                els.forEach(el => eventTypes.forEach(t => el.removeEventListener(t, handler)));
            }
        };
    }, [activeGuideFlow, currentStepIndex]);

    const currentGuideMessage = activeGuideFlow && GUIDE_FLOWS[activeGuideFlow] 
                                ? getStepMsg(GUIDE_FLOWS[activeGuideFlow][currentStepIndex])
                                : "";

    return {
        voiceAssist, setVoiceAssist, showGuideModal, setShowGuideModal,
        activeGuideFlow, currentGuideMessage, toggleVoiceAssist, handleVoiceClick,
        handleFocusVoice, handleSelectVoice, handleTextBlurVoice,
        startSmartGuide, endSmartGuide, advanceNextStep, speakHinglish, setPendingConfirm
    };
};

export default useWorkerSmartGuide;